import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { NavbarOfflineLink } from './NavbarOfflineLink';
export const NavbarButton = (props) => {
    if (props.offlineMode) {
        return (_jsx(NavbarOfflineLink, { text: props.text, children: props.children }, props.buttonKey));
    }
    return (_jsxs(ListItem, { button: true, onClick: props.onClick, children: [_jsx(ListItemIcon, { children: props.children }), _jsx(ListItemText, { primary: props.text })] }, props.buttonKey));
};
